export { countParts, partRows, SHAPE_DEFAULTS } from '../../lib/model-doc.js';

/** File-name friendly version of a model name. */
export function slugName(name: string): string {
  return (
    name
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'model'
  );
}
